export default "__VITE_ASSET__DREGF1SD__"